import React from 'react';
import { LayoutGrid, Table as TableIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
export const ViewToggle = ({ value, onChange }) => {
    const { t } = useTranslation('campaign');
    return (<div className="flex items-center gap-1 rounded-md border p-1">
            <Button size="icon" variant="ghost" className={cn(value === 'table' && 'bg-primary')} onClick={() => onChange('table')} aria-label={t('view_toggle.table_view')}>
                <TableIcon className="h-4 w-4"/>
            </Button>

            <Button size="icon" variant="ghost" className={cn(value === 'card' && 'bg-primary')} onClick={() => onChange('card')} aria-label={t('view_toggle.card_view')}>
                <LayoutGrid className="h-4 w-4"/>
            </Button>
        </div>);
};
ViewToggle.displayName = 'ViewToggle';
